import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';

export function detailPayroll(registreId) {
    let url = 'wage/detailPayroll?' + objectToQueryString({ registreId: registreId, userCode: UserCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let detail = response.list;

                //saveConfig(detail);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function documentPayroll(uid) {
    let url = 'wage/documentPayroll?' + objectToQueryString({ uid: uid, userCode: UserCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let document = response.document;

                //saveConfig(detail);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

function saveScheduler(config) {
    localStorage.setItem('wageScheduler', JSON.stringify(config));
}